import UserSlackAPI from './UserSlackAPI';

class UserIntegrationsAPI {
  static Slack: UserSlackAPI;
}

export default UserIntegrationsAPI;
